import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import { markNotificationAsRead as markNotificationAsReadAction } from 'actions/notification';
import moment from 'moment';
import ColorIndicator from 'UI/components/atoms/ColorIndicator';
import { icon as iconDimensions } from 'UI/constants/dimensions';
import { notificationIcons } from 'UI/constants/notifications';
import { AnnouncementIcon, colors } from 'UI/res';
import { VALIDATION_REGEXS } from 'UI/utils';

import { styles, useStyles } from './styles';

/**
 * @typedef {Object} NotificationCardProps
 * @property {*} notification
 * @property {*} markNotificationAsRead
 * @property {*} history
 * @property {Function} onCloseClick
 * @property {*} ref
 */

/**
 * @typedef {Object} IconListProps
 * @property {notificationsType} icon
 * @property {string} color
 */

/**
 * @param {IconListProps} props
 */
const IconList = props => {
  const { icon, color } = props;
  const notification = notificationIcons.find(n => {
    return n.key === icon;
  }) || { icon: <AnnouncementIcon /> };

  return {
    ...notification.icon,
    props: { fill: color, size: iconDimensions.size }
  };
};

/**
 * @param {NotificationCardProps} props
 */
const NotificationCard = props => {
  const { notification, markNotificationAsRead, history, onCloseClick, ref } = props;

  const classes = useStyles({
    indicatorColor: notification.read_on ? colors.lightgray : notification.color,
    createdColor: notification.read_on ? colors.oxford : colors.success
  });
  const backgroundCard = notification.read_on ? classes.read : classes.root;

  const handleClick = async item => {
    !item.read_on && markNotificationAsRead(item);
    onCloseClick && onCloseClick();
    const isFullUrl = VALIDATION_REGEXS.URL.test(item.click_action);
    if (isFullUrl) {
      window.open(item.click_action, '_blank');
    } else {
      history.push(item.click_action);
    }
  };

  return (
    <Card ref={ref} className={backgroundCard} onClick={() => handleClick(notification)}>
      <div className={classes.leftIndicator} />
      <CardActions className={classes.iconContainer}>
        <div className={classes.icon}>
          <IconList icon={notification.icon} color={notification.color} />
        </div>
      </CardActions>
      <CardContent>
        <div className={classes.textContainer}>
          <div className={classes.title} style={styles.truncateText}>
            {notification.title}
          </div>
          <div className={classes.body} style={styles.truncateText}>
            {notification.body}
          </div>
          <div className={classes.created}>{moment(notification.created_at).fromNow()}</div>
        </div>
      </CardContent>
      <CardActions className={classes.indicatorContainer}>
        <div className={classes.indicator}>
          {!notification.read_on && <ColorIndicator color={colors.success} size={12} />}
        </div>
      </CardActions>
    </Card>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    markNotificationAsRead: notification => dispatch(markNotificationAsReadAction(notification))
  };
};

export default connect(null, mapDispatchToProps)(withRouter(NotificationCard));
